import { Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import GoalGraph from "src/assets/GoalGraph";
import { useIsMobile } from "src/hooks/useIsMobile";

interface CardProps {
  currentWeight: number;
  goalWeight: number;
  currentLabel: string;
  goalLabel: string;
}

const GraphCard = ({
  currentWeight,
  currentLabel,
  goalLabel,
  goalWeight,
}: CardProps) => {
  const isMobile = useIsMobile();
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === "en";

  const currentLabelPosition = useMemo(() => {
    if (isMobile) {
      return !isEnglish ? 35 : 40;
    }
    {
      return !isEnglish ? 70 : 75;
    }
  }, [isEnglish, isMobile]);

  const goalLabelPosition = useMemo(() => {
    if (isMobile) {
      return !isEnglish ? 40 : 27;
    }
    {
      return !isEnglish ? 75 : 60;
    }
  }, [isEnglish, isMobile]);

  return (
    <Stack alignItems="center">
      <GoalGraph />
      <Stack
        direction="row"
        alignItems="center"
        sx={{ bottom: 15, position: "relative" }}
      >
        <Stack
          alignItems="center"
          position="relative"
          sx={{ right: currentLabelPosition }}
        >
          <Typography fontWeight={700} variant="h5">
            {currentWeight}
          </Typography>
          <Typography fontWeight={700} variant="h6">
            {currentLabel}
          </Typography>
        </Stack>
        <Stack
          alignItems="center"
          position="relative"
          sx={{ left: goalLabelPosition }}
        >
          <Typography fontWeight={700} variant="h5">
            {goalWeight}
          </Typography>
          <Typography fontWeight={700} variant="h6">
            {goalLabel}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
export default GraphCard;
